import { Alert as AntdAlert, AlertProps } from 'antd'

export const Alert = (props: AlertProps) => <AntdAlert {...props} />

